import { render, staticRenderFns } from "./RoleMainTab.html?vue&type=template&id=02227949&scoped=true&"
import script from "./RoleMainTab.ts?vue&type=script&lang=ts&"
export * from "./RoleMainTab.ts?vue&type=script&lang=ts&"
import style0 from "./RoleMainTab.scss?vue&type=style&index=0&id=02227949&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02227949",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
